import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import dizeeLogo from '../../assets/images/dizee logo.svg';

const NavContainer = styled(motion.nav)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
`;

const NavContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 5%;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  
  @media (max-width: 768px) {
    gap: 16px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

const LogoImage = styled.img`
  width: 64px;
  height: auto;
`;

const LogoText = styled.span`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
  letter-spacing: -0.01em;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;
  cursor: pointer;
  
  &:hover {
    color: white;
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const SignInButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 8px 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
  }
`;

const CTAButton = styled.button`
  background: transparent;
  border: none;
  padding: 10px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #FF2300;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.8;
  }
`;

const Navigation = ({ onSignIn, onScrollToSection, onAskDizee }) => {
  const navigate = useNavigate();
  
  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDocsClick = () => {
    navigate('/docs');
  };

  return (
    <NavContainer
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <NavContent>
        <LeftSection>
          <LogoContainer onClick={handleLogoClick}>
            <LogoImage src={dizeeLogo} alt="DIZEE" />
          </LogoContainer>
        </LeftSection>

        <RightSection>
          <NavLinks>
            <NavLink onClick={() => onScrollToSection('features')}>
              Features
            </NavLink>
            <NavLink onClick={() => onScrollToSection('pricing')}>
              Pricing
            </NavLink>
            <NavLink onClick={handleDocsClick}>
              Docs
            </NavLink>
          </NavLinks>
          <CTAButton onClick={onSignIn}>
            Get Started
          </CTAButton>
        </RightSection>
      </NavContent>
    </NavContainer>
  );
};

export default Navigation; 